webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_to_blob__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_to_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_to_blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App_vue__);





new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__components_App_vue___default.a);
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_github_badge__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_github_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_github_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_downloadjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var $ = document.querySelector.bind(document);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      form: {
        firstLine: 'neon',
        secondLine: 'genesis',
        thirdLine: 'evangelion',
        episode: 'episode:12',
        titleLine: 'She said,"Don\'t make others suffer\nfor your personal hatred."',
        titleFont: 'Serif'
      },
      canvasSize: {
        width: 1280 * 2,
        height: 720 * 2
      }
    };
  },

  watch: {
    form: {
      handler: function handler() {
        this.draw();
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.draw();
  },

  computed: {
    fontSize: function fontSize() {
      var firstTwoLines = this.canvasSize.height * 0.08;
      var thirdLine = firstTwoLines * 1.7;
      var episode = firstTwoLines * 0.5;

      return {
        firstTwoLines: firstTwoLines,
        thirdLine: thirdLine,
        episode: episode,
        titleSize: episode
      };
    }
  },
  methods: {
    draw: function draw() {
      var existing = $('#canvas');
      if (existing) {
        this.$refs.output.removeChild(existing);
      }

      var canvas = document.createElement('canvas');
      canvas.id = 'canvas';
      canvas.width = this.canvasSize.width;
      canvas.height = this.canvasSize.height;

      var context = canvas.getContext('2d');

      // For retina display
      context.scale(2, 2);

      // background
      context.fillStyle = 'black';
      context.fillRect(0, 0, this.canvasSize.width, this.canvasSize.height);

      var addText = function addText(text, y, squashRaito) {
        context.textBaseline = 'top';
        context.textAlign = 'left';

        var squashWidth = context.measureText(text).width * squashRaito;

        var split = text.split('\n');

        if (split.length > 1) {
          context.textBaseline = 'middle';
        } else {
          context.textBaseline = 'top';
        }

        split.forEach(function (line, index) {
          var mWidth = context.measureText('M').width;
          context.fillText(line, 40, y + index * mWidth, squashWidth);
        });
      };

      context.textBaseline = 'top';

      // First line
      context.font = '900 ' + this.fontSize.firstTwoLines + 'px Times New Roman';
      context.fillStyle = '#ffffff';
      addText(this.form.firstLine.toUpperCase(), 40, 0.7);

      // Second line
      addText(this.form.secondLine.toUpperCase(), 135, 0.7);

      // Third line
      context.font = '900 ' + this.fontSize.thirdLine + 'px Times New Roman';
      addText(this.form.thirdLine.toUpperCase(), 210, 0.6);

      // Episode line
      context.font = '700 ' + this.fontSize.episode + 'px Helvetica Neue,Helvetica,sans-serif';
      addText(this.form.episode.toUpperCase(), 420, 0.75);

      // Title line
      context.font = '900 ' + this.fontSize.titleSize + 'px ' + this.form.titleFont;
      addText(this.form.titleLine, 515, 0.6);

      this.$refs.output.appendChild(canvas);
    },
    download: function download() {
      var canvas = $('#canvas');
      canvas.toBlob(function (blob) {
        __WEBPACK_IMPORTED_MODULE_1_downloadjs___default()(blob, 'evangelion-card.png', 'image/png');
      });
    }
  },
  components: {
    Badge: __WEBPACK_IMPORTED_MODULE_0_vue_github_badge___default.a
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4)
  __webpack_require__(5)
  __webpack_require__(7)
  __webpack_require__(6)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(2),
  /* template */
  __webpack_require__(13),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5931494b",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/Users/egoist/dev/evangelion-card/src/components/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5931494b", Component.options)
  } else {
    hotAPI.reload("data-v-5931494b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('badge', {
    staticClass: "badge",
    attrs: {
      "slug": "egoist/evangelion-card"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "first-line"
    }
  }, [_vm._v("First Line")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.firstLine),
      expression: "form.firstLine"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "first-line"
    },
    domProps: {
      "value": (_vm.form.firstLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.firstLine = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "second-line"
    }
  }, [_vm._v("Second Line")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.secondLine),
      expression: "form.secondLine"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "second-line"
    },
    domProps: {
      "value": (_vm.form.secondLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.secondLine = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "third-line"
    }
  }, [_vm._v("Third Line")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.thirdLine),
      expression: "form.thirdLine"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "third-line"
    },
    domProps: {
      "value": (_vm.form.thirdLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.thirdLine = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "episode"
    }
  }, [_vm._v("\"EPISODE\"")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.episode),
      expression: "form.episode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "episode"
    },
    domProps: {
      "value": (_vm.form.episode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.episode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "title-line"
    }
  }, [_vm._v("Title Line")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.titleLine),
      expression: "form.titleLine"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title-line"
    },
    domProps: {
      "value": (_vm.form.titleLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.titleLine = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "title-font"
    }
  }, [_vm._v("Title Font")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.titleFont),
      expression: "form.titleFont"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title-font"
    },
    domProps: {
      "value": (_vm.form.titleFont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.titleFont = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column download"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('button', {
    staticClass: "download-button",
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Save as PNG")])])])]), _vm._v(" "), _c('div', {
    ref: "output",
    staticClass: "output"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5931494b", module.exports)
  }
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
module.exports = __webpack_require__(1);


/***/ })
],[16]);


// WEBPACK FOOTER //
// client.7d84e761.js